export default ".demo-jing-password-input {\n    background: #fff;\n}\n\n.demo-jing-password-input-keyboard {\n    padding-bottom: 300px !important;\n}"